import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { AlertTriangle } from 'react-feather'
import { RowBetween } from '../Row'
import { ButtonDark } from '../ButtonStyled'
import { AutoColumn } from '../Column'
import { Hover } from '..'
import Link from '../Link'
import { usedChain } from '../../constants'
import { ExplorerDataType, getExplorerLink } from '../../utils/etherscan'
import Modal from '../Modal'

const StyledWarningIcon = styled(AlertTriangle)`
  min-height: 24px;
  min-width: 24px;
  stroke: #f82d3a;
`

const WarningContent = styled.div`
  color: #f82d3a;
  padding-right: 2rem;

  @media screen and (max-width: 600px) {
    padding-right: 1rem;
  }
`

const WarningTitle = styled.div`
  font-family: 'Inter Display', sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: #f82d3a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`

const WarningText = styled(Text)`
  font-family: 'Inter Display', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 16px;
`

const UnderstandButton = styled(ButtonDark)`
  background: #f82d3a;
  border: 1px solid #f82d3a;
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 12px 32px;
  border-radius: 50px;
  min-width: 160px;
  height: 50px;

  &:hover {
    background: #d12734;
    border-color: #d12734;
  }
`

const EtherscanLink = styled(Link)`
  color: #4f9eff;
  text-decoration: underline;
  font-weight: 500;
  font-size: 16px;

  &:hover {
    color: #6ba6ff;
  }
`

export default function WarningModal({ type, show, setShow, address }) {
  return (
    <Modal isOpen={show} onClose={() => setShow(false)}>
      <WarningContent>
        <WarningTitle>
          <StyledWarningIcon size={24} />
          Token Safety Alert
        </WarningTitle>

        <AutoColumn gap="16px">
          <WarningText>
            Anyone can create and name any ERC20 token on Ethereum, including creating fake versions of existing tokens
            and tokens that claim to represent projects that do not have a token.
          </WarningText>

          <WarningText>
            Similar to Etherscan, this site automatically tracks analytics for all ERC20 tokens independent of token
            integrity. Please do your own research before interacting with any ERC20 token.
          </WarningText>

          <div style={{ marginTop: '8px', marginBottom: '24px' }}>
            <Hover>
              <EtherscanLink href={getExplorerLink(usedChain, address, ExplorerDataType.ADDRESS)} target="_blank">
                View {type === 'token' ? 'token' : 'pair'} contract on Etherscan →
              </EtherscanLink>
            </Hover>
          </div>

          <RowBetween>
            <div />
            <UnderstandButton onClick={() => setShow(false)}>I understand</UnderstandButton>
          </RowBetween>
        </AutoColumn>
      </WarningContent>
    </Modal>
  )
}
